import { useContext, useState } from 'react'

import { QuizContext } from '@f/applications/QuizApp/context/QuizContext'
import { QuizStep } from '@f/applications/QuizApp/partials/types'

import { $TSFixMe } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

export function useBudgetSubmitted(step: QuizStep) {
  const {
    actions: { updateValues }
  } = useContext(QuizContext) as $TSFixMe

  const [budgetSubmitted, setBudgetSubmitted] = useState<boolean>(false)

  const handleBudgetChange = (value: number | string) => {
    updateValues({
      stepID: step.id,
      valuesToSave: [
        {
          name: 'budget_range',
          value
        }
      ]
    })

    setBudgetSubmitted(true)
  }

  return {
    budgetSubmitted,
    handleBudgetChange
  }
}
